import { Body, styledPolymorphic } from '@qred/components-library';
import React from 'react';
import { FILL_TRANSITION_DURATION } from './constants';

const Container = styledPolymorphic()(
  (styled) => styled`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`
);

const LabelRow = styledPolymorphic()(
  (styled) => styled`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
);

const Track = styledPolymorphic()(
  (styled) => styled`
  display: flex;
  align-items: center;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background-color: ${({ theme }) =>
    theme.fn.themeColor('Main/Grey/Alpha/OnLight/10%')};
`
);

const Fill = styledPolymorphic()(
  (styled) => styled`
  height: 100%;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.fn.themeColor('Main/Primary/900')};
`
);

interface Props {
  label: string;
  progress: number;
}

export const ProgressBar: React.FC<Props> = ({ label, progress }) => (
  <Container>
    <LabelRow>
      <Body size="lg" color="Text/Secondary">
        {label}
      </Body>
      <Body size="lg" color="Text/Secondary">
        {Math.round(progress)}%
      </Body>
    </LabelRow>
    <Track>
      <Fill
        style={{
          width: `${progress}%`,
          transition: `width ${
            progress === 0 ? '0s' : `${FILL_TRANSITION_DURATION}s`
          } ease`,
        }}
      />
    </Track>
  </Container>
);
